// extracted by mini-css-extract-plugin
export default {"tableContent":"CollectionYardVisitEventsTable_tableContent__HGq1g"};